module.exports = __webpack_public_path__ + "img/falabella.8ac307b7.svg";